<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15nyXPN/tc-custom/9781466846609.jpg?1732049724721" alt="This image is the cover for the book Gulag"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gulag
      </h1>
      <p class="bookDescription body article font2">
        <p>KGB Colonel Rotislav Okulov is shot dead by his own agents while passing a deadly Soviet secret to the Americans. Now CIA agent Tony Bertonelli is the only one who knows what the colonel revealed with his dying breath. But in order to bring the information back home, Bertonelli must escape KGB operatives determined to keep the truth from the world—at any cost.<br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sean Flannery
      </h2>
      
      <p class="authorDescription body article"><B>Sean Flannery </B>is the pen name of author <B>David Hagberg</B>, a former Air Force cryptographer who has traveled extensively in Europe, the Arctic, and the Caribbean and has spoken at CIA functions. He has published more than twenty novels of suspense, including the bestselling <I>High Flight, Assassin, </I>and <I>Joshua’s Hammer.</I> He makes his home in Vero Beach, Florida.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates Book
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6e297945